import { render, staticRenderFns } from "./getfree-cart-item.vue?vue&type=template&id=15dfe6ec&scoped=true"
import script from "./getfree-cart-item.vue?vue&type=script&lang=js"
export * from "./getfree-cart-item.vue?vue&type=script&lang=js"
import style0 from "./getfree-cart-item.vue?vue&type=style&index=0&id=15dfe6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfe6ec",
  null
  
)

export default component.exports